<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { getBlock } from '@/core/block-registry';
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';
import { mapContentBlocks } from '@/core/collections/job-boards/job-board.helper';

const { currentJobBoard } = storeToRefs(useJobBoardStore());
const blocks = mapContentBlocks(currentJobBoard.value);
</script>

<template>
   <div>
      <div class="content-block-container" v-for="block in blocks || []" :key="block.id">
         <component :is="getBlock(block.type)?.components.content" :data="block.data" />
      </div>
   </div>
</template>

<style lang="scss" scoped>
.content-block-container {
   margin: 50px 5px;

   &:first-child {
      margin-top: 0;
   }
}
</style>
